import { useQuery } from '@tanstack/react-query'
import { apiClient, ApiError } from '@/services/apiClient'

export interface CredentialSetForService {
  id: string
  name: string
  entry_count: number
}

/**
 * Fetches CredentialSets that have at least one entry for the named
 * service slug. Used by the per-binding picker in PersonaToolBindings
 * to populate the credential-set dropdown.
 *
 * Empty `service` short-circuits the query (no fetch).
 */
export function useCredentialSetsForService(service: string) {
  return useQuery({
    queryKey: ['credential-sets', 'by-service', service],
    queryFn: async (): Promise<CredentialSetForService[]> => {
      const res = await apiClient.fetch(
        `/api/admin/credential-sets?service=${encodeURIComponent(service)}`,
      )
      // SA-947: the status rides the error, so a caller can word a 403.
      if (!res.ok) throw new ApiError(`Failed to load credential sets for ${service}`, res.status, null)
      return res.json()
    },
    enabled: service.length > 0,
  })
}
